"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionList = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Option_1 = require("./Option");
var __1 = require("../");
var OptionList = function (_a) {
    var className = _a.className, collapseValue = _a.collapseValue, flatGroup = _a.flatGroup, focusValue = _a.focusValue, groupClassName = _a.groupClassName, multiple = _a.multiple, onChange = _a.onChange, onExpand = _a.onExpand, onGroupSelectAll = _a.onGroupSelectAll, onGroupSelectNone = _a.onGroupSelectNone, optionClassName = _a.optionClassName, optionOnKeyDown = _a.optionOnKeyDown, options = _a.options, value = _a.value, props = __rest(_a, ["className", "collapseValue", "flatGroup", "focusValue", "groupClassName", "multiple", "onChange", "onExpand", "onGroupSelectAll", "onGroupSelectNone", "optionClassName", "optionOnKeyDown", "options", "value"]);
    var OptionsClasses = classnames_1.default('OptionList', className, {
        'OptionList--single-select': !multiple,
        'OptionList--multi-select': multiple,
    });
    var GroupClasses = classnames_1.default('OptionList__group', groupClassName);
    var ValuesFromArray = Array.isArray(value)
        ? value.map(function (v) {
            return v.value !== undefined ? v.value : v;
        })
        : null;
    var setDefaultOptionProperties = function (option) {
        var defaultSelected = false;
        if (value !== undefined &&
            option.value !== undefined &&
            ((Array.isArray(value) &&
                value.length > 0 &&
                ValuesFromArray.includes(option.value)) || // If value is an Array (multiple selections)
                (typeof value === 'object' && value.value === option.value)) // If value is an Object (single selection)
        ) {
            defaultSelected = true;
        }
        var defaults = {
            collapsed: option.collapsed ? option.collapsed : true,
            selected: defaultSelected,
            text: flatGroup && typeof option.content === 'string'
                ? option.content
                : option.text
                    ? option.text
                    : null,
        };
        return __assign(__assign({}, defaults), option);
    };
    var setInitialLevel = function () {
        return !flatGroup && options.some(function (option) { return option.options; }) ? 1 : 0;
    };
    /* Loops through options object to display grouped and non-grouped options */
    var getOptions = function (options, level) {
        if (level === void 0) { level = 1; }
        return options.map(function (optionProp, index) {
            var localOption = setDefaultOptionProperties(optionProp);
            var checkForChildren = !!localOption.options;
            if (checkForChildren) {
                if (!flatGroup)
                    return getGroupedOptions(localOption, optionProp, localOption.options, index, level, optionProp.value, optionProp.collapsed);
                if (level === 0)
                    return getFlatGroupedOptions(localOption.options, localOption.text, level, index);
            }
            return getOption(localOption, optionProp, !flatGroup ? level : 0);
        });
    };
    /* Called when the options prop is detected in an individual option */
    var getGroupedOptions = function (parentOption, originalParentOption, options, index, level, parentCollapseValue, collapsed) {
        /* Variable determines if an option should be expanded to show children */
        var isOpen = collapsed
            ? !collapsed
            : collapseValue
                ? collapseValue.includes(parentCollapseValue)
                : true;
        return (react_1.default.createElement("div", { className: GroupClasses, role: "group", key: index },
            getOption(parentOption, originalParentOption, level, true, isOpen, options),
            react_1.default.createElement(__1.Collapsible, { open: isOpen }, getOptions(options, level + 1))));
    };
    /* Pull flatGroup prop data for selection handling */
    var objectFlatGroup = typeof flatGroup === 'object' ? __assign({}, flatGroup) : undefined;
    var handleGroupSelectAll = function (groupedOptions) {
        if (objectFlatGroup.onGroupSelectAll === undefined)
            return;
        return objectFlatGroup.onGroupSelectAll(groupedOptions);
    };
    var handleGroupSelectNone = function (groupedOptions) {
        if (objectFlatGroup.onGroupSelectNone === undefined)
            return;
        return objectFlatGroup.onGroupSelectNone(groupedOptions);
    };
    var getFlatGroupedOptions = function (options, title, level, index) {
        var selectAll = function () { return handleGroupSelectAll(options); };
        var selectNone = function () { return handleGroupSelectNone(options); };
        return (react_1.default.createElement(react_1.default.Fragment, { key: "" + index + Object(options) },
            index !== 0 && react_1.default.createElement(__1.Divider, { spacing: 1 }),
            title && (react_1.default.createElement(__1.Stack, { alignItems: "center", className: "OptionList__header" },
                react_1.default.createElement(__1.Eyebrow, null, title),
                multiple && title && typeof flatGroup !== 'boolean' && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(__1.Link, { primary: true, className: "m-l-1 fs-1", onClick: selectAll }, "All"),
                    react_1.default.createElement(__1.Link, { primary: true, className: "m-l-1 fs-1", onClick: selectNone }, "None"))))),
            getOptions(options, level + 1)));
    };
    var handleOnChange = function () {
        if (onChange === undefined)
            return;
        return onChange;
    };
    var handleOnExpand = function () {
        if (onExpand === undefined)
            return;
        return onExpand;
    };
    /* Generates the individual option in the Option List */
    var getOption = function (option, originalOption, level, collapseControl, collapseBoolean, localOptions) {
        if (collapseControl === void 0) { collapseControl = false; }
        if (collapseBoolean === void 0) { collapseBoolean = false; }
        if (localOptions === void 0) { localOptions = []; }
        var _a = Object(option), className = _a.className, options = __rest(_a, ["className"]);
        var OptionClasses = classnames_1.default(className, optionClassName);
        return (react_1.default.createElement(Option_1.Option, __assign({}, options, { className: OptionClasses, collapseControl: collapseControl, collapsed: collapseBoolean, focus: focusValue && focusValue.value === Object(option).value, key: "" + Object(option).value + Object(option).text + level, level: level, onChange: handleOnChange(), onExpand: handleOnExpand(), onKeyDown: optionOnKeyDown, options: localOptions, selfObject: originalOption })));
    };
    return (react_1.default.createElement("div", __assign({ className: OptionsClasses }, props), getOptions(options, setInitialLevel())));
};
exports.OptionList = OptionList;
//# sourceMappingURL=OptionList.js.map